import { toPairs } from 'ramda'

import type { PutParams } from 'app/dataTypes/dishes/field'
import type { Dish } from 'app/dataTypes/dishes/dish'

import type { Request } from '../../../index'


type ApiParams = {
  id: number,
  field: string,
  new_value: string | null,
  item_types?: Array<'supplier' | 'school' | 'single' | 'complex'>,
}

type ApiParamsPhoto = {
  id: number
  field: string
  new_value: {
    file: string
    o?: number
    w: number
    x1: number
    y1: number
    x2: number
    y2: number
  } | null
}

export const convertParams = (params: PutParams): [ApiParams | ApiParamsPhoto, null] => {
  if (params.valueType === 'photo') {
    const { id, field, value } = params
    return [{
      id: parseInt(id, 10),
      field,
      new_value: value,
    }, null]
  }
  const { id, field, value, changeItemTypes } = params
  return [{
    id: parseInt(id, 10),
    field,
    new_value: value,
    item_types: changeItemTypes,
  }, null]
}


type ApiResult = Record<string, {
  id: number
  title: string
  photoUrl: string | null
  cost: string
  portion: string
  saleType: {
    id: number
    title: string
  }
  nomenclature: string | null
}> & {
  result: 'success'
}

export const convertResult = (data: ApiResult) => {
  const { result, ...others } = data
  const [[, value]] = toPairs(others)
  const { id, title, photoUrl, cost, portion, saleType, nomenclature } = value
  return {
    id: String(id),
    title,
    photoUrl: photoUrl || null,
    portion: portion || '',
    cost: String(cost),
    saleType: {
      id: String(saleType.id),
      title: saleType.title,
    },
    nomenclature: nomenclature || '',
  }
}


export const PUT_FOOD_ITEM_FIELD: Request<
  PutParams,
  Dish,
  null
> = [
  'food/item/field',
  'put',
  ['data'],
]
